export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-dribbble-c329ca3c627bff6256c5ace7910cf5cf.svg";